import './App.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Home from './components/Home';
import About from './components/About';
import AllBooks from './components/AllBooks';
import Contact from './components/Contact';
import RecommendedBooks from './components/RecommendedBooks';
import BooksByLanguage from './components/BooksByLanguage';
import PopularBooks from './components/PopularBooks';
import GenreRecommended from './components/GenreRecommended';
import NewlyAddedBooks from './components/NewlyAddedBooks';
import BooksByAgeGroup from './components/BooksByAgeGroup';
import ScrollToTop from './components/ScrollToTop';
import PDFViewer from './components/PDFViewer';
import EPUBViewer from './components/EPUBViewer';
import BookByGenre from './components/BookByGenre';
import BooksByAgeGroup8to11 from './components/BooksByAgeGroup8to11';
import BookByLanguageCatWise from './components/BookByLanguageCatWise';
import NewEpub from './components/NewEpub';
import Privacy from './components/Privacy';
import TermCondition from './components/TermCondition';
import ScrollToSection from './components/ScrollToSection';
import Nutrition from './components/Nutrition';
import NewHeader from './components/NewHeader';
import Footer from './components/Footer';
import PDFLoader from './components/PDFLoader';
import Gallery from './components/Gallery';
import ImageViewer from './components/ImageViewer';
import SummerCamp from './components/SummerCamp';
import Login from './components/Login';
import UserData from './components/UserData';
import CreateAccount from './components/CreateAccount';
import EditProfile from './components/EditProfile';
import Profile from './components/Profile';
import NewUserRegister from './components/NewUserRegister';
import ResetPassword from './components/ResetPassword';
import SendOTP from './components/SendOTP';
import VerifyOTP from './components/VerifyOTP';
import EditDetails from './components/EditDetails';
import PrivateRoute from './components/PrivateRoute';
import BookPopUp from './components/BookPopUp';
import DisableDevtool from 'disable-devtool'; 

function App() {
  const [book, setBook] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.fnKey && e.key === 'F9') {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const response = await axios.get(`${baseURL}/get_book_read_of_the_day/`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": apiKey,
          },
        });

        if (response.data.status_code === 200 && response.data.data) {

          const newBook = response.data.data;
          setBook(newBook);

          if (newBook.pop_up) {
            setShowPopup(true);
          }
        }
      } catch (err) {
        console.error("Fetch error:", err.message);
      }
    };

    fetchBook();

  }, [baseURL, apiKey]);

   DisableDevtool({
    ondevtoolopen: () => {
      window.location.href = "https://ndl.education.gov.in/api/upload/warning.html";
    }
  });


  return (
    <>
      <Router>
        <AuthProvider>
          <BookPopUp book={book} showPopup={showPopup} setShowPopup={setShowPopup} />
          <ScrollToTop />
          <NewHeader />
          <ScrollToSection />
          <Routes>
            <Route path="/language-books" element={<BookByLanguageCatWise />} />
            <Route path="/genre-books" element={<BookByGenre />} />
            <Route path="/edit_profile" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
            <Route path="/edit_detail" element={<EditDetails />} />
            <Route path="/userdata" element={<UserData />} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/age-group-books" element={<BooksByAgeGroup8to11 />} />
            <Route path="/epub" element={<EPUBViewer />} />
            <Route path="/pdf" element={<PDFViewer />} />
            <Route path="/epubnew" element={<NewEpub />} />
            <Route path="/pdf_loader" element={<PDFLoader />} />
            <Route path="/search/:query" element={<AllBooks />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/viewer" element={<ImageViewer />} />
            <Route path="/camp" element={<SummerCamp />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset_password" element={<ResetPassword />} />
            <Route path="/create_account" element={<CreateAccount />} />
            <Route path="/new_account" element={<NewUserRegister />} />
            <Route path="/edit_profile" element={<EditProfile />} />
            <Route path="/recommended_books" element={<RecommendedBooks />} />
            <Route path="/nutrition_books" element={<Nutrition />} />
            <Route path="/books_by_language" element={<BooksByLanguage />} />
            <Route path="/popular_books" element={<PopularBooks />} />
            <Route path="/genre_recommended" element={<GenreRecommended />} />
            <Route path="/newly_added_books" element={<NewlyAddedBooks />} />
            <Route path="/books_by_age_group" element={<BooksByAgeGroup />} />
            <Route path="/user_data" element={<UserData />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/sendotp" element={<SendOTP />} />
            <Route path="/verifyotp" element={<VerifyOTP />} />
            <Route path="/term_condition" element={<TermCondition />} />
          </Routes>
          <Footer />
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;
